module.exports = __webpack_public_path__ + "static/gifgroup-afecd96822488d0f884507ad2353d9b6.gif";